export const BID_STATUS = {
	PENDING: 'pending',
	APPROVED: 'approved',
	PENDING_DEPOSIT: 'pending_deposit',
	DEPOSIT_PAID: 'deposit_paid',
	PENDING_PAYMENT: 'pending_payment',
	PAID: 'paid',
	REJECTED: 'rejected',
	EXPIRED: 'expired',
	WITHDRAWN: 'withdrawn',
};

export const ALL_BID_STATUSES = Object.values(BID_STATUS);

export const BID_STATUS_LABELS = {
	pending: 'Awaiting customer',
	approved: 'Approved',
	pending_deposit: 'Pending Deposit',
	deposit_paid: 'Deposit Paid',
	pending_payment: 'Pending Payment',
	paid: 'Paid',
	rejected: 'Rejected',
	expired: 'Expired',
	withdrawn: 'Withdrawn',
};

export const BID_STATUS_COLORS = {
	pending: 'warning',
	pending_deposit: 'secondary',
	deposit_paid: 'success',
	pending_payment: 'info',
	paid: 'success',
	approved: 'success',
	rejected: 'error',
	expired: 'error',
	withdrawn: 'error',
};

export const BID_REASONS = {
	additional_work: 'Additional Work',
	material_price_increase: 'Material Price Increase',
	other: 'Other',
};
